class BlockEditorIframe {
	static SELECTOR_BLOCK_EDITOR_IFRAME_BODY = '.block-editor-iframe__body'
	static INSTANTIATION_DELAY = 2000

	constructor() {
		this.preventExternalActions()
	}

	/*
	 * Prevents external actions (like hyperlinks and submit buttons)
	 * from being triggered within the block editor iframe.
	 */
	preventExternalActions() {
		const blockEditorIframe = document.querySelector( BlockEditorIframe.SELECTOR_BLOCK_EDITOR_IFRAME_BODY )
		if ( blockEditorIframe ) {
			blockEditorIframe.querySelectorAll(
				'a, button[type="submit"], input[type="submit"], .wp-block-jtf-jtf-youtube',
			).forEach( function ( el ) {
				if ( el.matches( '.wp-block-jtf-jtf-youtube' ) ) {
					const btn = el.querySelector( '.jtf__mediablock button' )
					if ( btn ) {
						btn.addEventListener( 'click', function ( event ) {
							event.stopPropagation()
						} )
					}
				} else {
					el.addEventListener( 'click', function ( event ) {
						event.preventDefault()
					} )
				}
			} )
		}
	}
}

export default function init() {
	let blockEditorIframeBody = null

	setTimeout( () => {
		blockEditorIframeBody = document.querySelector( BlockEditorIframe.SELECTOR_BLOCK_EDITOR_IFRAME_BODY )

		if ( blockEditorIframeBody ) {
			new BlockEditorIframe()
		}
	}, BlockEditorIframe.INSTANTIATION_DELAY )
}